import { render, staticRenderFns } from "./StepFourDoc.vue?vue&type=template&id=3c5ea519&scoped=true"
import script from "./StepFourDoc.vue?vue&type=script&lang=ts"
export * from "./StepFourDoc.vue?vue&type=script&lang=ts"
import style0 from "./StepFourDoc.vue?vue&type=style&index=0&id=3c5ea519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ea519",
  null
  
)

export default component.exports